import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/faster-market-entry-through-integrated-ivdr-and-who-strategy")({
  head: () => buildRouteHead("/es/casos-de-exito/faster-market-entry-through-integrated-ivdr-and-who-strategy", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/acceso-mas-rapido-al-mercado-mediante-una-estrategia-integrada-ivdr-y-oms", replace: true });
  },
});
